/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_In_Reason_Return_From_ScentingInputs */

const vi_sl_in_reason_return_from_scenting = /** @type {(inputs: Sl_In_Reason_Return_From_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả về từ lấy hương`)
};

/**

* @param {Sl_In_Reason_Return_From_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_in_reason_return_from_scenting = /** @type {((inputs?: Sl_In_Reason_Return_From_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_In_Reason_Return_From_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_in_reason_return_from_scenting(inputs)
});